import {
  DURATION,
  listOfBooleanRequired,
  listOfCheckBoxFilters,
  listOfDateRequired,
  listOfFieldsNoFilter,
  listOfFieldsNotSortable,
  listOfFilterBlankRequired,
  listOfIntBooleanRequired,
  listOfNumberFilter,
} from "../../constants";
import DATA_MODEL_TABLE from "../../utils/constants/dataModelTable";
import BooleanRender from "./BooleanRender";
import ChipRender from "./ChipRender";
import DateRender from "./DateRender";
import LinkedInstanceRender from "./LinkedInstanceRender";
import { MY_LAB, SOP_RT, TOOL_PANELS } from "../../components/DLabGrid/dLabGridConstant";
import { find } from "lodash";
import MonitoringStatusRender from "./MonitoringStatusRender";
import InstrumentAvailabilityRender from "./InstrumentAvailabilityRender";
import BookingAccessControlRender from "./BookingAccessControlRender";
import QualificationCalibrationStatusRender from "./QualificationCalibrationStatusRender";
import { snackbarService } from "@one/web-components/dist/index.cjs.js";
import EquipmentStatusRender from "./EquipmentStatusRender";
import ChecklistRender from "./ChecklistRender";
import { getFieldValue } from "../booking-instruments/helpers";

export const getColumnObj = (value, masterDataFilters, autoGroupField = null) => {
  let colObj = value;

  colObj = {
    ...colObj,
    sortable: !listOfFieldsNotSortable?.includes(value.key),
  };

  if (value.key === DATA_MODEL_TABLE.linkedInstance?.key) {
    colObj = {
      ...colObj,
      cellRenderer: LinkedInstanceRender,
    };
  }

  if (value.key === DATA_MODEL_TABLE.tags?.key) {
    colObj = {
      ...colObj,
      cellRenderer: ChipRender,
    };
  }

  if (value.key === DATA_MODEL_TABLE.checklists.key) {
    colObj = {
      ...colObj,
      cellRenderer: ChecklistRender,
    };
  }

  if (autoGroupField && value.key === autoGroupField) {
    colObj = {
      ...colObj,
      hide: true,
      lockVisible: true,
    };
  }
  if (value.key === DATA_MODEL_TABLE.instrumentAvailability?.key) {
    colObj = {
      ...colObj,
      cellRenderer: InstrumentAvailabilityRender,
    };
  }
  if (value.key === DATA_MODEL_TABLE.instrumentStatus?.key) {
    colObj = {
      ...colObj,
      cellRenderer: MonitoringStatusRender,
    };
  }
  if (value.key === DATA_MODEL_TABLE.displayQualificationStatus?.key) {
    colObj = {
      ...colObj,
      cellRenderer: QualificationCalibrationStatusRender,
    };
  }
  if (value.key === "bookingAccessControl") {
    colObj = {
      ...colObj,
      cellRenderer: BookingAccessControlRender,
    };
  }
  if (value.key === DATA_MODEL_TABLE.status?.key) {
    colObj = {
      ...colObj,
      cellRenderer: EquipmentStatusRender,
    };
  }
  if (value.key === DATA_MODEL_TABLE.isHazardous?.key) {
    colObj = {
      ...colObj,
      valueGetter: (params) => {
        const hazardousValue = getFieldValue(params?.data, "is_hazardous");
        return !!+hazardousValue ? "Yes" : "No";
      },
    };
  }
  if (value.key === DATA_MODEL_TABLE.shouldAssisted?.key) {
    colObj = {
      ...colObj,
      valueGetter: (params) => {
        const shouldAssistedValue = getFieldValue(params?.data, "should_assisted");
        return !!+shouldAssistedValue ? "Yes" : "No";
      },
    };
  }
  if (listOfDateRequired?.includes(value.key)) {
    colObj = {
      ...colObj,
      cellClass: "action-render",
      cellRenderer: DateRender,
      filter: "agDateColumnFilter",
      filterParams: {
        filterOptions: ["equals", "lessThan", "greaterThan", "inRange"],
        inRangeFloatingFilterDateFormat: "DD-MMM-YYYY",
        suppressAndOrCondition: true,
        defaultJoinOperator: "OR",
        buttons: ["reset", "apply"],
      },
    };
  } else if (listOfBooleanRequired?.includes(value.key)) {
    colObj = {
      ...colObj,
      cellClass: "action-render",
      cellRenderer: BooleanRender,
      filter: "agSetColumnFilter",
      filterParams: {
        defaultToNothingSelected: true,
        showTooltips: true,
        buttons: ["reset"],
        values: (params) => {
          let values = ["true", "false"];
          if (listOfIntBooleanRequired?.includes(value.key))
            values = ["Yes", "No"];
          params.success(values);
        },
      },
    };
  } else if (listOfCheckBoxFilters?.includes(value.key)) {
    colObj = {
      ...colObj,
      filter: "agSetColumnFilter",
      filterParams: {
        buttons: ["reset"],
        defaultToNothingSelected: true,
        values: (params) => {
          const values = masterDataFilters[value.key] || [];
          params.success(values);
        },
      },
    };

  } else if (listOfNumberFilter?.includes(value.key)) {
    colObj = {
      ...colObj,
      filter: "agNumberColumnFilter",
      filterParams: {
        filterOptions: ["equals", "lessThan", "greaterThan", "inRange"],
        defaultJoinOperator: "OR",
        buttons: ["reset", "apply"],
      },
    };
  } else if (!listOfFieldsNoFilter.includes(value.key)) {
    colObj = {
      ...colObj,
      filter: "agTextColumnFilter",
      filterParams: {
        filterOptions: listOfFilterBlankRequired?.includes(value.key) ? ["contains", "blank"] : ["contains"],
        buttons: ["reset", "apply"],
        defaultToNothingSelected: true,
        defaultJoinOperator: "OR",
        values: (params) => {
          const values = masterDataFilters[value.key] || [];
          params.success(values);
        },
      },
    };
  }

  return colObj;
};

export const getColumnObjClient = (value) => {
  let colObj = value;

  colObj = {
    ...colObj,
    sortable: !listOfFieldsNotSortable?.includes(value.key),
  };
  if (listOfBooleanRequired?.includes(value.key)) {
    colObj = {
      ...colObj,
      cellClass: "action-render",
      cellRenderer: BooleanRender,
    };
  }

  if (value.key === DATA_MODEL_TABLE.linkedInstance?.key) {
    colObj = {
      ...colObj,
      cellRenderer: LinkedInstanceRender,
    };
  }

  if (value.key === DATA_MODEL_TABLE.tags?.key) {
    colObj = {
      ...colObj,
      cellRenderer: ChipRender,
    };
  }

  if (listOfDateRequired?.includes(value.key)) {
    colObj = {
      ...colObj,
      cellClass: "action-render",
      cellRenderer: DateRender,
    };
  }

  return colObj;
};
//======================FILTER FUNCTIONC===================
export const onUpdateFilter = async ({
  lastFavFilter,
  isSaveConfigUpdated = false,
  updateRedux = true,
  id,
  email,
  client,
  query,
  userProfileQuery,
  updateLastFavFilter = null,
  isAdminModifyingOtherUserFilter = false,
  modifiedBy,
}) => {
  let lastFilterData = {};
  lastFilterData.lastFavFilter = lastFavFilter;
  lastFilterData = JSON.stringify(lastFilterData);
  let result = null;
  try {
    if (!isAdminModifyingOtherUserFilter) {
      result = await client.mutate({
        mutation: userProfileQuery,
        variables: { id, email, lastFilter: lastFilterData, modifiedBy },
      });
    }

    if (isSaveConfigUpdated) {
      const filterDefinition =
        typeof lastFavFilter?.filterDefinition === "string"
          ? lastFavFilter?.filterDefinition
          : JSON.stringify(lastFavFilter?.filterDefinition);
      const userFilterUpdateResult = await client.mutate({
        mutation: query,
        variables: {
          userID: id,
          filterName: lastFavFilter?.filterName,
          filterDefinition,
          modifiedBy,
        },
        fetchPolicy: "no-cache",
      });
      if (isAdminModifyingOtherUserFilter) {
        result = userFilterUpdateResult;
      }
    }

    if (isSaveConfigUpdated) {
      snackbarService.show({
        type: "success",
        message: `Updated filter successfully `,
        duration: DURATION,
      });
    }
  } catch (error) {
    if (isSaveConfigUpdated) {
      snackbarService.show({
        type: "error",
        message: "Failed to update filter",
        duration: DURATION,
      });
    }
    result = null;
  }
  if (updateRedux && updateLastFavFilter) {
    updateLastFavFilter(lastFavFilter);
  }
  return result;
};

export const onCreatefilter = async ({
  id,
  email,
  name,
  site,
  client,
  userFilters,
  lastFavFilter,
  query,
  userProfileQuery,
  updateUserFilters = null,
  updateLastFavFilter = null,
}) => {
  let result = null;
  try {
    const FilterNameMatch = userFilters.filter((item) => item.filterName === lastFavFilter?.filterName?.trim());

    if (FilterNameMatch.length === 0 && lastFavFilter?.filterName !== MY_LAB) {
      result = await client.mutate({
        mutation: query,
        variables: {
          userID: id,
          createdBy: name || email || id,
          site: site,
          filterDefinition: JSON.stringify(lastFavFilter?.filterDefinition),
          filterName: lastFavFilter.filterName?.trim(),
        },
      });
      if (result) {
        await onUpdateFilter({
          lastFavFilter,
          updateLastFavFilter,
          userProfileQuery,
          id,
          email,
          client,
        });
        if (updateUserFilters) {
          updateUserFilters([...userFilters, lastFavFilter]);
        }
      }

      snackbarService.show({
        type: "success",
        message: `Filters successfully saved `,
        duration: DURATION,
      });
    } else {
      snackbarService.show({
        type: "warning",
        message: `Duplicate filter name `,
        duration: DURATION,
      });
    }
  } catch (err) {
    console.log(err);
    snackbarService.show({
      type: "warning",
      icon: "caution",
      appName: "",
      message: `Filter creation failure `,
    });
  }

  return result;
};

//===============COLUMN FUNCTIONS=================
export const onUpdateSelectColumn = async ({
  data,
  isSaveConfigUpdated = false,
  updateLastDisplayColumnWhenEmptyData = true,
  updateRedux = true,
  id,
  email,
  name,
  client,
  userProfileQuery,
  query,
  userDisplayList,
  updateUserDisplayColumns = null,
  updateLastDisplayColumn = null,
  updateLastDisplayColumnDefinition = null,
}) => {
  let result = null;
  try {
    result = await client.mutate({
      mutation: userProfileQuery,
      variables: { id, email, lastDisplayColumns: data },
      fetchPolicy: "no-cache",
    });

    if (isSaveConfigUpdated) {
      const updateData = typeof data === "string" ? JSON.parse(data) : data;
      const displayDefinition =
        typeof updateData?.displayDefinition === "string"
          ? updateData?.displayDefinition
          : JSON.stringify(updateData?.displayDefinition);
      await client.mutate({
        mutation: query,
        variables: {
          userID: id,
          modifiedBy: name || email || id,
          displayName: updateData?.displayName,
          displayDefinition,
        },
        fetchPolicy: "no-cache",
      });
      const displayObj = typeof data === "string" ? JSON.parse(data) : data;
      userDisplayList = userDisplayList?.map((userDisplay) => {
        if (displayObj?.displayName === userDisplay?.displayName) {
          return displayObj;
        }
        return userDisplay;
      });

      if (updateUserDisplayColumns) {
        updateUserDisplayColumns([...userDisplayList]);
      }
    }

    if (isSaveConfigUpdated) {
      snackbarService.show({
        type: "success",
        message: `Updated columns set successfully `,
        duration: DURATION,
      });
    }
  } catch (error) {
    if (isSaveConfigUpdated) {
      snackbarService.show({
        type: "warning",
        message: `Failed to update columns set`,
        duration: DURATION,
      });
    }
    return null;
  }

  if (updateRedux && updateLastDisplayColumn) {
    let parsed = data;
    if (typeof data === "string") {
      try {
        parsed = JSON.parse(data);
      } catch (err) {
        parsed = null;
      }
    }

    if (parsed?.displayName || updateLastDisplayColumnWhenEmptyData) {
      updateLastDisplayColumn(data);
    } else if (parsed?.displayName === "" && updateLastDisplayColumnDefinition) {
      updateLastDisplayColumnDefinition(parsed)
    }
  }

  return result;
};

export const onCreateSelectColumn = async ({
  id,
  email,
  name,
  site,
  userDisplayList,
  unParsedData,
  client,
  query,
  userProfileQuery,
  updateUserDisplayColumns = null,
  updateLastDisplayColumn = null,
}) => {
  let result = null;
  const columnMatches = userDisplayList.filter((item) => item.displayName === unParsedData?.displayName?.trim());
  if (columnMatches?.length === 0 && unParsedData?.displayName !== "SOP RT0020") {
    let columnObj = {
      displayName: unParsedData?.displayName,
      userID: id,
      createdBy: name || email || id,
      site,
      displayDefinition: JSON.stringify(unParsedData?.displayDefinition),
    };

    try {
      result = await client.mutate({
        mutation: query,
        variables: columnObj,
        fetchPolicy: "no-cache",
      });

      if (result) {
        await onUpdateSelectColumn({
          data: JSON.stringify(unParsedData),
          updateLastDisplayColumn,
          userProfileQuery,
          id,
          email,
          name,
          client,
        });

        userDisplayList = [...userDisplayList, result?.data?.createUserDisplay];
        if (updateUserDisplayColumns) {
          updateUserDisplayColumns([...userDisplayList]);
        }
      }

      snackbarService.show({
        type: "success",
        message: `Columns Set successfully saved`,
        duration: DURATION,
      });
    } catch (error) {
      snackbarService.show({
        type: "warning",
        message: `Failed to save columns set`,
        duration: DURATION,
      });
    }
  } else {
    snackbarService.show({
      type: "warning",
      message: "Duplicate column name",
      duration: DURATION,
    });
  }
  return result;
};

//==============onChip delete======================

export const onDeleteSaveConfigurations = async ({
  userID,
  email,
  client,
  chipToDelete,
  panel,
  lastSavedChip,
  userProfileQuery,
  deleteFilterQuery,
  deleteColumnQuery,
  userFilters,
  userDisplayList,
  updateUserFilters = null,
  updateUserDisplayColumns = null,
  updateLastFavFilter = null,
  updateLastDisplayColumn = null,
  setDisplayPreset = null,
  setSavedFilter = null
}) => {
  let result = null;
  let variables = { userID: chipToDelete?.userID || userID };
  if (panel === TOOL_PANELS.filters) {
    variables = {
      ...variables,
      filterName: chipToDelete?.filterName,
    };
  } else if (panel === TOOL_PANELS.columns) {
    variables = {
      ...variables,
      displayName: chipToDelete?.displayName,
    };
  }
  try {
    result = await client.mutate({
      mutation: panel === TOOL_PANELS.filters ? deleteFilterQuery : deleteColumnQuery,
      variables,
    });
    if (panel === TOOL_PANELS.filters) {
      const removeIndex = userFilters.findIndex((item) => item.filterName === chipToDelete?.filterName);
      userFilters.splice(removeIndex, 1);
      if (lastSavedChip?.filterName === chipToDelete?.filterName) {
        await onUpdateFilter({
          lastFavFilter: {
            filterDefinition: chipToDelete?.filterDefinition,
            filterName: "",
          },
          userProfileQuery,
          updateLastFavFilter,
          id: userID,
          email,
          client,
        });
      }
      const updateFilter = [...userFilters];
      if (find(updateFilter, { filterName: MY_LAB })) {
        updateFilter.shift();
      }
      if (updateUserFilters) {
        updateUserFilters([...updateFilter]);
      }
    } else {
      if (setDisplayPreset) {
        setDisplayPreset(null)
      }
      const removeIndex = userFilters.findIndex((item) => item.displayName === chipToDelete?.displayName);
      userFilters.splice(removeIndex, 1);
      const savedColumn = typeof lastSavedChip === "string" ? JSON.parse(lastSavedChip) : lastSavedChip;
      if (savedColumn?.displayName === chipToDelete?.displayName) {
        await onUpdateSelectColumn({
          data: JSON.stringify({
            displayDefinition:
              typeof chipToDelete?.displayDefinition === "string"
                ? JSON.parse(chipToDelete?.displayDefinition)
                : chipToDelete?.displayDefinition,
            displayName: "",
          }),
          updateLastDisplayColumn,
          userProfileQuery,
          id: userID,
          email,
          client,
        });
      }
      const updateColumns = [...userFilters];
      if (find(updateColumns, { displayName: SOP_RT })) {
        updateColumns.shift();
      }
      userDisplayList = [...updateColumns];
      if (updateUserDisplayColumns) {
        updateUserDisplayColumns([...updateColumns]);
      }
    }
    snackbarService.show({
      type: "success",
      message: panel === TOOL_PANELS.filters ? "Filter successfully deleted" : "Columns set successfully deleted",
      duration: DURATION,
    });
  } catch (err) {
    snackbarService.show({
      type: "warning",
      message: panel === TOOL_PANELS.filters ? "Filter deletion failure" : "Columns set deletion failure",
      duration: DURATION,
    });
  }
  return { result, userFilters, panel };
};

export const saveLastPageSize = async ({ lastPageSize, query, updateLastPageSize, id, email, client }) => {
  try {
    await client.mutate({
      mutation: query,
      variables: { id, email, lastPageSize },
    });
    updateLastPageSize(lastPageSize);
  } catch (err) {
    console.log(" last page size fetch!", { err });
  }
};
